import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Button = styled.button`
    display: flex;
    font-family: ${theme.fonts.book};
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${theme.colors.midnight};
`;

export const Badge = styled.span`
    display: inline-block;
    font-family: ${theme.fonts.book};
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${theme.colors.midnight};
`;

export const Title = styled.h2`
    display: flex;
    margin-bottom: ${theme.space[3] / 2}px;
    font-family: ${theme.fonts.book};
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${theme.colors.midnight};

    ${Badge} + & {
        margin-right: ${theme.space[1]}px;
    }

    html[dir="rtl"] & {
        ${Badge} + & {
            margin-left: ${theme.space[1]}px;
            margin-right: 0;
        }
    }
`;

export const Text = styled.div`
    padding-bottom: ${theme.space[1]}px;
    font-family: ${theme.fonts.book};
    font-size: 1.2rem;
    letter-spacing: 0.5%;
    line-height: 1.8rem;
    text-align: start;
`;

export const DisclaimerContainer = styled.div`
    margin: ${theme.space[4]}px 0;
`;

type DisclaimerPropsType = {
    genericDisclaimer: boolean;
    collapsed: boolean;
    shouldCollapse?: boolean;
    fullHeight: number;
    hasDarkBackground?: boolean;
};

export const Wrapper = styled.div<DisclaimerPropsType>`
    &:not(:only-child),
    &:not(:last-child) {
        margin-bottom: ${theme.space[4]}px;
    }

    ${Text} {
        position: relative;
        margin-bottom: ${theme.space[1]}px;

        ${({ shouldCollapse, collapsed, genericDisclaimer, hasDarkBackground }) =>
            shouldCollapse &&
            !genericDisclaimer &&
            css`
                max-height: ${collapsed ? "60px" : "auto"};
                padding-bottom: 20px;
                transition: max-height 0.3s;
                overflow: hidden;

                &:after {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 40px;
                    content: "";
                    background: ${hasDarkBackground
                        ? "linear-gradient(to right, rgba(226, 232, 239, 0.5), #E2E8EF 75%, #E2E8EF)"
                        : "linear-gradient(to right, rgba(255, 255, 255, 0.5), #fff 75%, #fff)"};
                    transition: opacity 0.3s;
                    opacity: ${collapsed ? 1 : 0};
                }
            `};

        ${({ shouldCollapse, collapsed, genericDisclaimer }) =>
            shouldCollapse &&
            genericDisclaimer &&
            css`
                @media ${getBreakpoint("down", "md")} {
                    max-height: ${!collapsed ? "auto" : "60px"};
                    overflow: hidden;
                }
            `};
    }
`;
